import { authAxios as axios } from "shared-auth";

import config from "config/global";

class AttachmentService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async create(
    file: File,
    onProgress?: (percent: number) => void
  ): Promise<string> {
    const data = new FormData();
    data.append("file", file);

    const response = await axios(this.url, {
      method: "post",
      data,
      onUploadProgress: (event) =>
        onProgress?.(Math.round((event.loaded * 100) / (event.total || 1))),
    });

    return response.data;
  }
}

export const attachmentsApiUrl = `${config.linkboardApiUrl}/attachments`;

export default new AttachmentService({
  url: attachmentsApiUrl,
});
